import React from 'react';
import './about.scss';
import { SlickSlider } from '../SlickSlider/SlickSlider';

export function About() {
  return (
    <section id="home" className="center">
      <h3 className='about-lead'>
        Все виды ветеринарных услуг · Зоомагазин · Грумминг
      </h3>
      <SlickSlider />
      <p>Ветеринарная клиника <span className="pattaya">
        «Наоли»</span> — единственная клиника в Янино для домашних животных.
      </p>
      <p>Мы прежде всего ориентированы на  высококачественную круглосуточную ветеринарную помощь домашним животным. В нашей клинике свою деятельность ведут опытные ветеринарные врачи: терапевты, хирурги, специалисты визуальной диагностики, узкопрофильные специалисты.</p>
      <p>В нашем распоряжении имеются все необходимые лекарственные препараты, лабораторное и диагностическое оборудование.</p><p>Если возникнет необходимость, то к вашим услугам предлагается ветеринарная аптека. В ней имеются все необходимые препараты для лечения Ваших питомцев. У нас Вы найдёте лекарства без долгих поисков и с гарантией высокого качества!</p><p>Также при нашей ветеринарной клинике работает диспетчерская служба «ветеринарной помощи на дому».</p><p>Мы работаем круглосуточно без выходных и праздничных дней!</p><p>Желаем вам приятного посещения и здоровья вашим питомцам!</p>
      <hr />
      <p className="right">С заботой и уважением, <br />
        коллектив ветклиники <span className="pattaya">«Наоли»</span></p>
    </section>
  );
}
